export default "__VITE_ASSET__56d01081__"